const ADD_TO_LIST = (state, value) => {
  state.list[value.key] = value;
};

const REMOVE_FROM_LIST = (state, value) => {
  delete state.list[value];
};

const CLEAR_LIST = (state, value) => {
  state.list = {};
};

export default {
  ADD_TO_LIST,
  REMOVE_FROM_LIST,
  CLEAR_LIST,
};
